define(['jquery', './locale','./utilities', 'jquery-ui/ui/widgets/draggable'], function($, loc, utilities){
	'use strict';

	var PLUGIN_NAME = 'formSlider';

	var DEFAULTS = {
		updateLabel: false,
		type: 'linear'
	};

	// The actual plugin constructor
	function FormSlider(element, options) {
		this.element = element;

		this.options = $.extend(true, {}, DEFAULTS, options);

		this._defaults = DEFAULTS;
		this._name = PLUGIN_NAME;

		this.$me = $(this.element);

		this.objects = {};
		this.data = {};

		// FIXME - obcas se slider zobrazi za maximalni hranici (vizualne nad inputem)
		// coz mj. znamena, ze nelze vybrat maximum (posun se zarazi na cca 80 %).
		// Odlozenou inicializaci by se sirky slideru mely prepocitat podle uz aplikovanych CSS
		// bug se projevuje na sirkem i uzkem rozliseni, rychlem i pomalem pripojeni
		window.setTimeout(()=>{
			// console.log(`SLIDER>defered init()`);
			this.initialise();
		},1);
	}

	/**
	 * init
	 */
	FormSlider.prototype.initialise = function() {
		var self = this;

		self.objects.$slider = self.renderHtml();
		self.mapObjects();
		self.getData();


		if ( self.options.type == 'monthly-premium' ) {
			self.updateMonthlyPremiumState(false);
			self.initMonthlyPremiumHandler();
		} else if ( self.options.type == 'net-monthly-income' ) {
			self.updateNetMonthlyIncomeState(false);
			self.initNetMonthlyIncomeHandler();
		} else if ( self.options.type == 'monthly-instalment' ) {
			self.updateMonthlyInstalmentState(false);
			self.initMonthlyInstalmentHandler();
		} else if ( self.options.type == 'rate' ) {
			self.updateRateState(false);
			self.initRateHandler();
		} else {
			self.updateState(false);
			self.initHandler();
		}

		self.bindEvents();
	};

	FormSlider.prototype.mapObjects = function() {
		var self = this;

		self.objects.$input = self.$me.find('input');
		self.objects.$handler = self.objects.$slider.find('a');
		self.objects.$range = self.objects.$slider.find('.range');
		self.objects.$bar = self.objects.$slider.find('.bar');
	};

	FormSlider.prototype.getData = function() {
		var self = this;
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));
		self.data.min = self.objects.$input.data('min');
		self.data.max = self.objects.$input.data('max');
		self.data.step = self.objects.$input.data('step');
		self.data.units = self.objects.$input.data('units');
		self.data.flags = self.objects.$input.data('flags');
		self.data.maxHtmlRange = 0;
	};

	/**
	 *  bind all custom events
	 */
	FormSlider.prototype.bindEvents = function() {
		var self = this;

		$(window).on('resizeEnd.formSlider', function() {
			if ( self.options.type == 'monthly-premium' ) {
				self.updateMonthlyPremiumState(false);
			} else if ( self.options.type == 'net-monthly-income' ) {
				self.updateNetMonthlyIncomeState(false);
			} else if ( self.options.type == 'monthly-instalment' ) {
				self.updateMonthlyInstalmentState(false);
			} else if ( self.options.type == 'rate' ) {
				self.updateRateState(false);
			} else {
				self.updateState(false);
			}
		});
		self.$me.off('show.formSlider').on('show.formSlider', function(){
			if ( self.options.type == 'monthly-premium' ) {
				self.updateMonthlyPremiumState(false);
			} else if ( self.options.type == 'net-monthly-income' ) {
				self.updateNetMonthlyIncomeState(false);
			} else if ( self.options.type == 'monthly-instalment' ) {
				self.updateMonthlyInstalmentState(false);
			} else if ( self.options.type == 'rate' ) {
				self.updateRateState(false);
			} else {
				self.updateState(false);
			}
		});
		self.objects.$handler.off('click.formSlider').on('click.formSlider', function(e){
			e.preventDefault();
		});
		self.objects.$input.off('change.formSlider').on('change.formSlider', function(){
			if ( self.options.type == 'monthly-premium' ) {
				self.updateMonthlyPremiumState(true);
			} else if ( self.options.type == 'net-monthly-income' ) {
				self.updateNetMonthlyIncomeState(true);
			} else if ( self.options.type == 'monthly-instalment' ) {
				self.updateMonthlyInstalmentState(true);
			} else if ( self.options.type == 'rate' ) {
				self.updateRateState(true);
			} else {
				self.updateState(true);
			}
		});
	};

	/**
	 * render HTML of formSlider
	 */
	FormSlider.prototype.renderHtml = function() {
		var self = this,
			// $html = $('<div class="slider col-xxs-12 col-xs-8 col-sm-9 col-md-10"><div class="range"><div class="bar"></div><a href="#"></a></div></div>');
			$html = $('<div class="slider"><div class="range"><div class="bar"></div><a href="#"></a></div></div>');

		self.$me.append($html);
		return $html;
	};


	/**
	 * return max range of HTML component in pixels
	 *
	 */
	FormSlider.prototype.getMaxHtmlRange = function() {
		var self = this;
		return (self.objects.$range.width() - self.objects.$handler.outerWidth());
	};

	/**
	 * return current html position in pixel of slider handler
	 * @param value
	 * @param minValue
	 * @param maxValue
	 * @param maxHtmlRange
	 * @return {Number}
	 */
	FormSlider.prototype.getHandlerHtmlValue = function(value, minValue, maxValue, maxHtmlRange) {
		return Math.round((maxHtmlRange / (maxValue - minValue)) * (value - minValue));
	};

	/**
	 * return current real value of actual slider position
	 * @param value
	 * @param minValue
	 * @param maxValue
	 * @param maxHtmlRange
	 * @return {Number}
	 */
	FormSlider.prototype.getSliderValue = function(value, minValue, maxValue, maxHtmlRange) {
		return (Math.round((value / maxHtmlRange) * (maxValue-minValue)) + minValue);
	};

	/**
	 * return current real value of actual slider position rounded by step value
	 * @param value
	 * @param step
	 * @return {Number}
	 */
	FormSlider.prototype.getRoundedSliderValue = function(value, step) {
		return (Math.ceil(value / step) * step);
	};

	/**
	 * update state of component
 	 */
	FormSlider.prototype.updateState = function(state) {
		var self = this;

		self.data.maxHtmlRange = self.getMaxHtmlRange();
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));

		if ((self.data.default >= self.data.min) && (self.data.default <= self.data.max)) {
			self.updateSlider(self.getHandlerHtmlValue(self.data.default, self.data.min, self.data.max, self.data.maxHtmlRange));
			if (self.options.updateLabel) {
				self.updateLabel(self.data.default);
			}
		}

		var labelText = $('label', self.$me).text().replace('?', '').trim();
		var formTitle = $(self.$me).parents('.item').data('title');
		if ( formTitle == undefined ) {
			var parent = $(self.$me).parents('.container');
			formTitle = $('h1', parent).text();
		}

		if ( state == true ) {
			self.fireEventToAnalytics( formTitle, labelText, self.data.default, 'klávesnice');
		}

	};

	FormSlider.prototype.updateMonthlyPremiumState = function(state) {
		var self = this;

		self.data.maxHtmlRange = self.getMaxHtmlRange();
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));

		var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 66);
		// console.log('breakpoint1:' + breakpoint);
		var updateSliderValue;

		if ( self.data.default < 900 ) {
			updateSliderValue = Math.round(breakpoint / ( 600 / (self.data.default - self.data.min)));
		} else if ( self.data.default == 900 ) {
			updateSliderValue = breakpoint;
		} else {
			updateSliderValue = Math.abs(Math.round(( 900 - self.data.default - ( breakpoint * ((self.data.max - 900) / (Math.round((self.data.maxHtmlRange / 100) * 34))))) / ((self.data.max - 900) / (Math.round((self.data.maxHtmlRange / 100) * 34)))));
		}

		if ((self.data.default >= self.data.min) && (self.data.default <= self.data.max)) {
			self.updateSlider(updateSliderValue);
			if (self.options.updateLabel) {
				self.updateLabel(self.data.default);
			}
		}

		var labelText = $('label', self.$me).text().replace('?', '').trim();
		var formTitle = $(self.$me).parents('.item').data('title');
		if ( formTitle == undefined ) {
			var parent = $(self.$me).parents('.container');
			formTitle = $('h1', parent).text();
		}

		if ( state == true ) {
			self.fireEventToAnalytics( formTitle, labelText, self.data.default, 'klávesnice');
		}
	};

	FormSlider.prototype.updateNetMonthlyIncomeState = function(state) {
		var self = this;

		self.data.maxHtmlRange = self.getMaxHtmlRange();
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));

		var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 66);
		// console.log('breakpoint1:' + breakpoint);
		var updateSliderValue;

		if ( self.data.default < 28000 ) {
			updateSliderValue = Math.round(breakpoint / ( 27700 / (self.data.default - self.data.min)));
		} else if ( self.data.default == 28000 ) {
			updateSliderValue = breakpoint;
		} else {
			updateSliderValue = Math.abs(Math.round(( 28000 - self.data.default - ( breakpoint * ((self.data.max - 28000) / (Math.round((self.data.maxHtmlRange / 100) * 34))))) / ((self.data.max - 28000) / (Math.round((self.data.maxHtmlRange / 100) * 34)))));
		}

		if ((self.data.default >= self.data.min) && (self.data.default <= self.data.max)) {
			self.updateSlider(updateSliderValue);
			if (self.options.updateLabel) {
				self.updateLabel(self.data.default);
			}
		}

		var labelText = $('label', self.$me).text().replace('?', '').trim();
		var formTitle = $(self.$me).parents('.item').data('title');
		if ( formTitle == undefined ) {
			var parent = $(self.$me).parents('.container');
			formTitle = $('h1', parent).text();
		}

		if ( state == true ) {
			self.fireEventToAnalytics( formTitle, labelText, self.data.default, 'klávesnice');
		}
	};

	FormSlider.prototype.updateMonthlyInstalmentState = function(state) {
		var self = this;

		self.data.maxHtmlRange = self.getMaxHtmlRange();
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));

		var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 55);
		// console.log('breakpoint1:' + breakpoint);
		var updateSliderValue;

		if ( self.data.default < 15000 ) {
			updateSliderValue = Math.round(breakpoint / ( 15000 / (self.data.default - self.data.min)));
		} else if ( self.data.default == 15000 ) {
			updateSliderValue = breakpoint;
		} else {
			updateSliderValue = Math.abs(Math.round(( 15000 - self.data.default - ( breakpoint * ((self.data.max - 15000) / (Math.round((self.data.maxHtmlRange / 100) * 45))))) / ((self.data.max - 15000) / (Math.round((self.data.maxHtmlRange / 100) * 45)))));
		}

		if ((self.data.default >= self.data.min) && (self.data.default <= self.data.max)) {
			self.updateSlider(updateSliderValue);
			if (self.options.updateLabel) {
				self.updateLabel(self.data.default);
			}
		}

		var labelText = $('label', self.$me).text().replace('?', '').trim();
		var formTitle = $(self.$me).parents('.item').data('title');
		if ( formTitle == undefined ) {
			var parent = $(self.$me).parents('.container');
			formTitle = $('h1', parent).text();
		}

		if ( state == true ) {
			self.fireEventToAnalytics( formTitle, labelText, self.data.default, 'klávesnice');
		}
	};

	FormSlider.prototype.updateRateState = function(state) {
		var self = this;

		self.data.maxHtmlRange = self.getMaxHtmlRange();
		self.data.default = parseInt(self.objects.$input.val().replace(/ /g,''));

		if ((self.data.default >= self.data.min) && (self.data.default <= self.data.max)) {
			self.updateSlider(self.getHandlerHtmlValue(self.data.default, self.data.min, self.data.max, self.data.maxHtmlRange));
			if (self.options.updateLabel) {
				self.updateLabel(self.data.default);
			}
		}

		var labelText = $('label', self.$me).text().replace('?', '').trim();
		var formTitle = $(self.$me).parents('.item').data('title');
		if ( formTitle == undefined ) {
			var parent = $(self.$me).parents('.container');
			formTitle = $('h1', parent).text();
		}

		if ( state == true ) {
			self.fireEventToAnalytics( formTitle, labelText, self.data.default, 'klávesnice');
		}
	};

	/**
	 * update handler by position of handler
	 * @param position
	 */
	FormSlider.prototype.updateSlider = function(position) {
		var self = this;
		self.objects.$handler.css('left', position);
		self.objects.$bar.css('width', position);
	};

	/**
	 * update label by current value
	 */
	FormSlider.prototype.updateLabel = function(value) {
		var self = this,
			units;

		if (self.data.units == 'czk') {
			units = getLocale('czk');
		}
		else if (self.data.units == 'yrs') {
			units = getLocaleVariant('years',value);
		}
		else if (self.data.units == 'mts') {
			units = getLocaleVariant('months',value);
		}

		self.$me.find('label strong').text(utilities.formatInteger(value) + ' ' + units);
		self.$me.trigger('afterLabelChanged');
	};

	/**
	 * update input by current value
	 * @param value
	 */
	FormSlider.prototype.updateInputForDrag = function(value) {
		var self = this;
		if (value > self.data.max) {
			value = self.data.max;
		}
		if (value < self.data.min) {
			value = self.data.min;
		}

		self.objects.$input.val(value.toString());
	};

	FormSlider.prototype.updateInput = function(value) {
		var self = this;
		if (value > self.data.max) {
			value = self.data.max;
		}
		if (value < self.data.min) {
			value = self.data.min;
		}

		self.objects.$input.val(value.toString()).trigger('sliderChanged');
	};

	FormSlider.prototype.fireEventToAnalytics = function( formTitle, labelText, valueToAnalytics, inputType ) {

		dataLayer .push({
			'event': 'fgWebAnalytics',
			'fgVarType': 'Formuláře',
			'fgVarCat': formTitle,
			'fgVarAct': labelText,
			'fgVarLbl': valueToAnalytics,
			'fgVarTxt': ''
		});

		dataLayer .push({
			'event': 'fgWebAnalytics',
			'fgVarType': 'Formuláře - UX',
			'fgVarCat': formTitle,
			'fgVarAct': labelText,
			'fgVarLbl': inputType, //buď bude 'táhlo ', nebo ' klávesnice '
			'fgVarTxt': ''
		});

		//console.log(formTitle);
		//console.log(labelText);
		//console.log(valueToAnalytics);
		//console.log(inputType);
	};

	/**
	 * init handler (draggable)
	 */
	FormSlider.prototype.initHandler = function() {
		var self = this;
		var globalRoundedValue = 0;

		self.objects.$handler.draggable({
			axis: 'x',
			containment: 'parent',
			distance: 1,
			drag: function(event,ui){
				var position = ui.position.left,
					value = self.getSliderValue(position, self.data.min, self.data.max, self.data.maxHtmlRange),
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				self.updateSlider(position);
				if (self.options.updateLabel) {
					self.updateLabel(roundedValue);
				}
				self.updateInputForDrag(roundedValue);
				globalRoundedValue = roundedValue;
			},
			stop: function(){
				$(window).trigger({
					type: 'sliderStop',
					senderId: self.$me.attr('id')
				});

				self.objects.$input.trigger('sliderChanged');
				self.updateInput(globalRoundedValue);

				var labelText = $('label', self.$me).text().replace('?', '').trim();
				var formTitle = $(self.$me).parents('.item').data('title');
				if ( formTitle == undefined ) {
					var parent = $(self.$me).parents('.container');
					formTitle = $('h1', parent).text();
				}
				self.fireEventToAnalytics( formTitle, labelText, globalRoundedValue, 'táhlo');
				// if (self.objects.$input.hasClass('manuallyRequestValidation')) {
					self.objects.$input.trigger('requestValidation');
				// }

			}
		});
	};

	/**
	 * init handler (draggable)
	 */
	FormSlider.prototype.initMonthlyPremiumHandler = function() {
		var self = this;
		var globalRoundedValue = 0;

		self.objects.$handler.draggable({
			axis: 'x',
			containment: 'parent',
			distance: 1,
			drag: function(event,ui){
				var position = ui.position.left, value, roundedValue;
				var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 66);
				if ( position <= breakpoint ) {
					value = self.getSliderValue(position, self.data.min, 900, breakpoint);
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				} else {
					value = Math.round(((900) + (( position - breakpoint ) * ((self.data.max - 900) / (Math.round((self.data.maxHtmlRange / 100) * 34))))));
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				}
				self.updateSlider(position);
				if (self.options.updateLabel) {
					self.updateLabel(roundedValue);
				}
				self.updateInputForDrag(roundedValue);
				globalRoundedValue = roundedValue;
			},
			stop: function(){
				$(window).trigger({
					type: 'sliderStop',
					senderId: self.$me.attr('id')
				});
				self.objects.$input.trigger('sliderChanged');
				self.updateInput(globalRoundedValue);

				var labelText = $('label', self.$me).text().replace('?', '').trim();
				var formTitle = $(self.$me).parents('.item').data('title');
				if ( formTitle == undefined ) {
					var parent = $(self.$me).parents('.container');
					formTitle = $('h1', parent).text();
				}
				self.fireEventToAnalytics( formTitle, labelText, globalRoundedValue, 'táhlo');
				// if (self.objects.$input.hasClass('manuallyRequestValidation')) {
					self.objects.$input.trigger('requestValidation');
				// }
			}
		});
	};

	FormSlider.prototype.initNetMonthlyIncomeHandler = function() {
		var self = this;
		var globalRoundedValue = 0;

		self.objects.$handler.draggable({
			axis: 'x',
			containment: 'parent',
			distance: 1,
			drag: function(event,ui){
				var position = ui.position.left, value, roundedValue;
				var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 66);
				if ( position <= breakpoint ) {
					value = self.getSliderValue(position, self.data.min, 28000, breakpoint);
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				} else {
					value = Math.round(((28000) + (( position - breakpoint ) * ((self.data.max - 28000) / (Math.round((self.data.maxHtmlRange / 100) * 34))))));
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				}
				self.updateSlider(position);
				if (self.options.updateLabel) {
					self.updateLabel(roundedValue);
				}
				self.updateInputForDrag(roundedValue);
				globalRoundedValue = roundedValue;
			},
			stop: function(){
				$(window).trigger({
					type: 'sliderStop',
					senderId: self.$me.attr('id')
				});
				self.objects.$input.trigger('sliderChanged');
				self.updateInput(globalRoundedValue);

				var labelText = $('label', self.$me).text().replace('?', '').trim();
				var formTitle = $(self.$me).parents('.item').data('title');
				if ( formTitle == undefined ) {
					var parent = $(self.$me).parents('.container');
					formTitle = $('h1', parent).text();
				}
				self.fireEventToAnalytics( formTitle, labelText, globalRoundedValue, 'táhlo');
				// if (self.objects.$input.hasClass('manuallyRequestValidation')) {
					self.objects.$input.trigger('requestValidation');
				// }
			}
		});
	};

	FormSlider.prototype.initMonthlyInstalmentHandler = function() {
		var self = this;
		var globalRoundedValue = 0;

		self.objects.$handler.draggable({
			axis: 'x',
			containment: 'parent',
			distance: 1,
			drag: function(event,ui){
				var position = ui.position.left, value, roundedValue;
				var breakpoint = Math.round((self.data.maxHtmlRange / 100) * 55);
				if ( position <= breakpoint ) {
					value = self.getSliderValue(position, self.data.min, 15000, breakpoint);
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				} else {
					value = Math.round(((15000) + (( position - breakpoint ) * ((self.data.max - 15000) / (Math.round((self.data.maxHtmlRange / 100) * 45))))));
					roundedValue = self.getRoundedSliderValue(value, self.data.step);
				}
				self.updateSlider(position);
				if (self.options.updateLabel) {
					self.updateLabel(roundedValue);
				}
				self.updateInputForDrag(roundedValue);
				globalRoundedValue = roundedValue;
			},
			stop: function(){
				$(window).trigger({
					type: 'sliderStop',
					senderId: self.$me.attr('id')
				});
				self.objects.$input.trigger('sliderChanged');
				self.updateInput(globalRoundedValue);

				var labelText = $('label', self.$me).text().replace('?', '').trim();
				var formTitle = $(self.$me).parents('.item').data('title');
				if ( formTitle == undefined ) {
					var parent = $(self.$me).parents('.container');
					formTitle = $('h1', parent).text();
				}
				self.fireEventToAnalytics( formTitle, labelText, globalRoundedValue, 'táhlo');
				// if (self.objects.$input.hasClass('manuallyRequestValidation')) {
					self.objects.$input.trigger('requestValidation');
				// }
			}
		});
	};

	FormSlider.prototype.initRateHandler = function() {
		var self = this;
		var globalRoundedValue = 0;

		self.objects.$handler.draggable({
			axis: 'x',
			containment: 'parent',
			distance: 1,
			drag: function(event,ui){
				var position = ui.position.left,
					//value = self.getSliderValue(position, self.data.min, self.data.max, self.data.maxHtmlRange),
					value = (((position / self.data.maxHtmlRange) * (self.data.max - self.data.min)) + self.data.min),
					//roundedValue = self.getRoundedSliderValue(value, self.data.step);
					roundedValue = Math.round(value * 100) / 100;
				self.updateSlider(position);
				if (self.options.updateLabel) {
					self.updateLabel(roundedValue);
				}
				self.updateInputForDrag(roundedValue);
				globalRoundedValue = roundedValue;
			},
			stop: function(){
				$(window).trigger({
					type: 'sliderStop',
					senderId: self.$me.attr('id')
				});
				self.objects.$input.trigger('sliderChanged');
				self.updateInput(globalRoundedValue);

				var labelText = $('label', self.$me).text().replace('?', '').trim();
				var formTitle = $(self.$me).parents('.item').data('title');
				if ( formTitle == undefined ) {
					var parent = $(self.$me).parents('.container');
					formTitle = $('h1', parent).text();
				}
				self.fireEventToAnalytics( formTitle, labelText, globalRoundedValue, 'táhlo');
				// if (self.objects.$input.hasClass('manuallyRequestValidation')) {
					self.objects.$input.trigger('requestValidation');
				// }
			}
		});
	};

	/**
	 * decide, which methods will be "public"
	 */
	var API = {
		//action: FormSlider.prototype.action
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 *         if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function(value) {
		var args = arguments;

		return this.each(function() {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new FormSlider(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.formSlider.js